import { WorkspaceDetails } from "@common/types/workspace";

export function getBillingOwnerOrganizationForWorkspace(
    workspaceDetails: WorkspaceDetails,
) {
    return (
        workspaceDetails.organizationAssignments.find(
            (oa) => oa.billingOwnership,
        )?.organization ?? null
    );
}

export function workspaceOwnsBilling(workspaceDetails: WorkspaceDetails) {
    const organizationThatOwnsBilling =
        getBillingOwnerOrganizationForWorkspace(workspaceDetails);
    return !organizationThatOwnsBilling;
}
